var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "accordion-content",
      class: ["accordion-content--" + _vm.layout],
    },
    [
      _vm.heading
        ? _c("h2", { staticClass: "accordion-content__heading" }, [
            _vm._v(_vm._s(_vm.heading)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description && _vm.description.length
        ? _c("div", {
            staticClass: "accordion-content__description",
            domProps: { innerHTML: _vm._s(_vm.description) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.content, function (item, index) {
        return _c(
          "article",
          {
            key: index + "-" + item.slug,
            staticClass: "accordion-content__item",
            class: {
              "accordion-content__item--open": _vm.selectedSlugs.includes(
                item.slug
              ),
            },
          },
          [
            _vm.layout === "complex"
              ? _c(
                  "div",
                  { staticClass: "accordion-content__item__complex-header" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "accordion-content__item__complex-header__image",
                      },
                      [
                        _c("lazy-image", {
                          attrs: {
                            src: item.image.sizes.large,
                            alt: item.image.alt,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "accordion-content__item__complex-header__body",
                        class: {
                          "accordion-content-row__body--with-arrow":
                            item.content && item.content.length,
                        },
                      },
                      [
                        _c("h4", {
                          staticClass:
                            "accordion-content__item__complex-header__body__title",
                          domProps: { innerHTML: _vm._s(item.title) },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "rich-text",
                          domProps: { innerHTML: _vm._s(item.introduction) },
                        }),
                        _vm._v(" "),
                        item.content && item.content.length
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "accordion-content__item__complex-header__body__read-more-link",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.didSelectItem(item)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Read More")])]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    item.content && item.content.length
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "accordion-content__item__complex-header__overlay",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.didSelectItem(item)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Read More"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _c("div", { staticClass: "accordion-content__item__header" }, [
                  _c(
                    "h2",
                    { staticClass: "accordion-content__item__header__title" },
                    [_vm._v(_vm._s(item.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.didSelectItem(item)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Read More"),
                      ]),
                    ]
                  ),
                ]),
            _vm._v(" "),
            _c(
              "Body",
              {
                staticClass: "accordion-content__item__body",
                attrs: {
                  pose: _vm.selectedSlugs.includes(item.slug)
                    ? "open"
                    : "closed",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "accordion-content__item__body__inner" },
                  [
                    _c(
                      "div",
                      { staticClass: "accordion-content__item__body__content" },
                      [
                        _c("div", {
                          staticClass: "rich-text",
                          domProps: { innerHTML: _vm._s(item.content) },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/AccordionContent.vue